// extracted by mini-css-extract-plugin
module.exports = {"searchBar":"styles_searchBar__1PbQK"};